import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_portalvue_2f63a5cd from 'nuxt_plugin_portalvue_2f63a5cd' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_pluginclient_e471faa8 from 'nuxt_plugin_pluginclient_e471faa8' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_18ff1798 from 'nuxt_plugin_pluginserver_18ff1798' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_apollomodule_77b2e812 from 'nuxt_plugin_apollomodule_77b2e812' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_sentryclient_23d9742d from 'nuxt_plugin_sentryclient_23d9742d' // Source: ../plugins/sentry/sentry.client.ts (mode: 'client')
import nuxt_plugin_sentryserver_ecda3496 from 'nuxt_plugin_sentryserver_ecda3496' // Source: ../plugins/sentry/sentry.server.ts (mode: 'server')
import nuxt_plugin_sentryperformance_63c560eb from 'nuxt_plugin_sentryperformance_63c560eb' // Source: ../plugins/helpers/sentry-performance.ts (mode: 'server')
import nuxt_plugin_apploaderclient_3e62a3ee from 'nuxt_plugin_apploaderclient_3e62a3ee' // Source: ../plugins/app-loader.client.ts (mode: 'client')
import nuxt_plugin_store_22197a6c from 'nuxt_plugin_store_22197a6c' // Source: ../plugins/helpers/store.ts (mode: 'all')
import nuxt_plugin_provider_5a1c9bdc from 'nuxt_plugin_provider_5a1c9bdc' // Source: ../plugins/helpers/provider.ts (mode: 'all')
import nuxt_plugin_generateRoute_43aadc99 from 'nuxt_plugin_generateRoute_43aadc99' // Source: ../plugins/helpers/generateRoute.ts (mode: 'all')
import nuxt_plugin_highlight_1617dc8e from 'nuxt_plugin_highlight_1617dc8e' // Source: ../plugins/helpers/highlight.ts (mode: 'all')
import nuxt_plugin_gateKeeper_170c82b0 from 'nuxt_plugin_gateKeeper_170c82b0' // Source: ../plugins/helpers/gateKeeper.ts (mode: 'all')
import nuxt_plugin_clipboardclient_3310156a from 'nuxt_plugin_clipboardclient_3310156a' // Source: ../plugins/helpers/clipboard.client.ts (mode: 'client')
import nuxt_plugin_outsideClickclient_e4ca7c12 from 'nuxt_plugin_outsideClickclient_e4ca7c12' // Source: ../plugins/helpers/outsideClick.client.ts (mode: 'client')
import nuxt_plugin_directivesclient_32b8c050 from 'nuxt_plugin_directivesclient_32b8c050' // Source: ../plugins/helpers/directives.client.ts (mode: 'client')
import nuxt_plugin_localstorageclient_002a8b84 from 'nuxt_plugin_localstorageclient_002a8b84' // Source: ../plugins/helpers/localstorage.client.ts (mode: 'client')
import nuxt_plugin_error_0ef6bbe5 from 'nuxt_plugin_error_0ef6bbe5' // Source: ../plugins/helpers/error.ts (mode: 'all')
import nuxt_plugin_ownerFeatures_4f8ad8dd from 'nuxt_plugin_ownerFeatures_4f8ad8dd' // Source: ../plugins/helpers/ownerFeatures.ts (mode: 'all')
import nuxt_plugin_toastsclient_58d7b83a from 'nuxt_plugin_toastsclient_58d7b83a' // Source: ../plugins/components/toasts.client.ts (mode: 'client')
import nuxt_plugin_floatingVue_44204e20 from 'nuxt_plugin_floatingVue_44204e20' // Source: ../plugins/components/floatingVue.ts (mode: 'all')
import nuxt_plugin_faviconclient_b04d891c from 'nuxt_plugin_faviconclient_b04d891c' // Source: ../plugins/favicon.client.ts (mode: 'client')
import nuxt_plugin_pluginclient_2678a076 from 'nuxt_plugin_pluginclient_2678a076' // Source: ../plugins/websocket/plugin.client.ts (mode: 'client')
import nuxt_plugin_iconCacheclient_63d9e727 from 'nuxt_plugin_iconCacheclient_63d9e727' // Source: ../plugins/iconCache.client.ts (mode: 'client')
import nuxt_plugin_analyticsclient_796b6e5f from 'nuxt_plugin_analyticsclient_796b6e5f' // Source: ../plugins/services/analytics.client.ts (mode: 'client')
import nuxt_plugin_stripeclient_8cafd2d2 from 'nuxt_plugin_stripeclient_8cafd2d2' // Source: ../plugins/stripe.client.ts (mode: 'client')
import nuxt_plugin_trackingAnalyticsclient_0e778128 from 'nuxt_plugin_trackingAnalyticsclient_0e778128' // Source: ../plugins/services/trackingAnalytics.client.ts (mode: 'client')
import nuxt_plugin_adTrackingclient_03fe77e9 from 'nuxt_plugin_adTrackingclient_03fe77e9' // Source: ../plugins/services/adTracking.client.ts (mode: 'client')
import nuxt_plugin_trackEventclient_f047e484 from 'nuxt_plugin_trackEventclient_f047e484' // Source: ../plugins/services/trackEvent.client.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"title":"DeepSource","bodyAttrs":{"class":"antialiased stroke-2"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Your team is writing more code with AI. DeepSource automates code reviews so you ship to production faster — catching security issues, improving code quality, and helping your team write better code."},{"hid":"og:type","property":"og:type","content":"website"},{"name":"theme-color","content":"#121317"},{"name":"robots","content":"noindex, nofollow"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png","sizes":"180x180"}],"script":[{"src":"https:\u002F\u002Fbetteruptime.com\u002Fwidgets\u002Fannouncement.js","data-id":"145541","async":"async"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_2f63a5cd === 'function') {
    await nuxt_plugin_portalvue_2f63a5cd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_e471faa8 === 'function') {
    await nuxt_plugin_pluginclient_e471faa8(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_18ff1798 === 'function') {
    await nuxt_plugin_pluginserver_18ff1798(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_77b2e812 === 'function') {
    await nuxt_plugin_apollomodule_77b2e812(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_23d9742d === 'function') {
    await nuxt_plugin_sentryclient_23d9742d(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_ecda3496 === 'function') {
    await nuxt_plugin_sentryserver_ecda3496(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryperformance_63c560eb === 'function') {
    await nuxt_plugin_sentryperformance_63c560eb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apploaderclient_3e62a3ee === 'function') {
    await nuxt_plugin_apploaderclient_3e62a3ee(app.context, inject)
  }

  if (typeof nuxt_plugin_store_22197a6c === 'function') {
    await nuxt_plugin_store_22197a6c(app.context, inject)
  }

  if (typeof nuxt_plugin_provider_5a1c9bdc === 'function') {
    await nuxt_plugin_provider_5a1c9bdc(app.context, inject)
  }

  if (typeof nuxt_plugin_generateRoute_43aadc99 === 'function') {
    await nuxt_plugin_generateRoute_43aadc99(app.context, inject)
  }

  if (typeof nuxt_plugin_highlight_1617dc8e === 'function') {
    await nuxt_plugin_highlight_1617dc8e(app.context, inject)
  }

  if (typeof nuxt_plugin_gateKeeper_170c82b0 === 'function') {
    await nuxt_plugin_gateKeeper_170c82b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboardclient_3310156a === 'function') {
    await nuxt_plugin_clipboardclient_3310156a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_outsideClickclient_e4ca7c12 === 'function') {
    await nuxt_plugin_outsideClickclient_e4ca7c12(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directivesclient_32b8c050 === 'function') {
    await nuxt_plugin_directivesclient_32b8c050(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localstorageclient_002a8b84 === 'function') {
    await nuxt_plugin_localstorageclient_002a8b84(app.context, inject)
  }

  if (typeof nuxt_plugin_error_0ef6bbe5 === 'function') {
    await nuxt_plugin_error_0ef6bbe5(app.context, inject)
  }

  if (typeof nuxt_plugin_ownerFeatures_4f8ad8dd === 'function') {
    await nuxt_plugin_ownerFeatures_4f8ad8dd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toastsclient_58d7b83a === 'function') {
    await nuxt_plugin_toastsclient_58d7b83a(app.context, inject)
  }

  if (typeof nuxt_plugin_floatingVue_44204e20 === 'function') {
    await nuxt_plugin_floatingVue_44204e20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_faviconclient_b04d891c === 'function') {
    await nuxt_plugin_faviconclient_b04d891c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_2678a076 === 'function') {
    await nuxt_plugin_pluginclient_2678a076(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iconCacheclient_63d9e727 === 'function') {
    await nuxt_plugin_iconCacheclient_63d9e727(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analyticsclient_796b6e5f === 'function') {
    await nuxt_plugin_analyticsclient_796b6e5f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_stripeclient_8cafd2d2 === 'function') {
    await nuxt_plugin_stripeclient_8cafd2d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trackingAnalyticsclient_0e778128 === 'function') {
    await nuxt_plugin_trackingAnalyticsclient_0e778128(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_adTrackingclient_03fe77e9 === 'function') {
    await nuxt_plugin_adTrackingclient_03fe77e9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trackEventclient_f047e484 === 'function') {
    await nuxt_plugin_trackEventclient_f047e484(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
